<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="align-self-center pl-3 mr-auto">
        <div class="d-flex flex-column">
          <div class="titre-h3 secondary--text ">
            Produits
          </div>
          <div class="titre-h5 secondary--text ">
            <span class="secondary--text align-self-center ">{{ produits[0].typeCulture.nom }}</span>
          </div>
        </div>
      </div>
      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-3 mx-4">
      <v-card
        v-for="produit in produits"
        :key="produit.id"
        class="pa-2 mb-2 background"
      >
        <div class="d-flex justify-space-between">
          <div class="secondary--text titre-h5">
            <span v-if="isMaisGrainOuSorgo && produit.typeRubrique.libelleSousRubrique === 'Rendement'">
              Rendement sec
            </span>
            <span v-else-if="isMaisGrainOuSorgo && produit.typeRubrique.libelleSousRubrique === 'Prix de vente'">Prix net de frais de séchage</span>
            <span v-else>{{ produit.typeRubrique.libelleSousRubrique }}</span>
            <v-chip
              v-if="produit.typeRubrique.statut === 'OBLIGATOIRE'"
              small
              class="ml-2"
              color="secondary"
            >
              <span class="text-lowercase">
                {{ produit.typeRubrique.statut | capitalize }}
              </span>
            </v-chip>
          </div>

          <div class="d-flex justify-space-around">
            <AgrButton
              icon
              @click="onOpenUpdateParametreModal(produit)"
            >
              <v-icon color="grey darken-2">
                mdi-pencil-outline
              </v-icon>
            </AgrButton>
          </div>
        </div>

        <div
          v-if="produit.typeRubrique.libelleSousRubrique !== 'Aides couplées'"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur min
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ produit.valeurMin != null ? produit.valeurMin : '-' }} {{ produit.typeRubrique.libelleSousRubrique !== 'Rendement' ? produit.unite : uniteRendement }}
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="texte py-0 texte-gris-fonce">
            Valeur défaut
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ produit.valeurDefaut != null ? produit.valeurDefaut : '-' }} {{ produit.typeRubrique.libelleSousRubrique !== 'Rendement' ? produit.unite : uniteRendement }}
          </div>
        </div>
        <div
          v-if="produit.typeRubrique.libelleSousRubrique !== 'Aides couplées'"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur max
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ produit.valeurMax != null ? produit.valeurMax : '-' }} {{ produit.typeRubrique.libelleSousRubrique !== 'Rendement' ? produit.unite : uniteRendement }}
          </div>
        </div>
      </v-card>
      <div class="d-flex justify-space-around my-4">
        <AgrButton
          class="pa-5"
          outlined
          block
          @click="onClose()"
        >
          Fermer
        </AgrButton>
      </div>
      <v-dialog
        v-if="isUpdateParametreModalOpen"
        v-model="isUpdateParametreModalOpen"
        width="500"
      >
        <UpdateParametreModal
          :parametre="parametre"
          :unite="parametre.typeRubrique.libelleSousRubrique !== 'Rendement' ? parametre.unite : uniteRendement"
          :is-aide-couplee="parametre.typeRubrique.libelleSousRubrique === 'Aides couplées'"
          @close="closeModalNouveauParametre()"
          @updatedParametre="updatedParametre"
        />
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import UpdateParametreModal from './update-parametre-modal.vue'

export default {
  name: 'UpdateProduitModal',
  components: {AgrButton, UpdateParametreModal},
  props: {
    produits: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      erreur: null,
      isUpdateParametreModalOpen: false,
      parametre: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
      }
    }
  },

  computed: {

    isLinFibre () {
      return this.produits[0].typeCulture && (this.produits[0].typeCulture.code === 'LFH' || this.produits[0].typeCulture.code === 'LFP')
    },
    isMaisGrainOuSorgo () {
      return this.produits[0].typeCulture && (this.produits[0].typeCulture.code === 'MG' || this.produits[0].typeCulture.code === 'SGG')
    },
    uniteRendement () {
      if (this.isLinFibre) {
        return 'kg/ha'
      } else if (this.produits[0].typeCulture.isUniteAfficheeTonneParHectare) {
        return 't/ha'
      } else {
        return 'qx/ha'
      }
    }
  },

  methods: {
    onClose () {
      this.$emit('close')
    },
    closeModalNouveauParametre () {
      this.isUpdateParametreModalOpen = false
    },
    onOpenUpdateParametreModal (value) {
      this.parametre = value
      this.isUpdateParametreModalOpen = true
    },
    updatedParametre () {
      this.$emit('updatedParametre', this.produits[0].typeCulture.id)
      this.isUpdateParametreModalOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.background {
  background: #EFF0E1;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
